<mat-accordion style="width:100%;padding-left:10px;">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{cat.Name}}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div cdkDropList (cdkDropListDropped)="CatOrFileDropped($event, cat.CategoryID)" style="max-height:600px;overflow-y:auto;">
      <div cdkDrag [cdkDragDisabled]="!CurUser.IsTolomaticUser" [cdkDragData]="{type:'cat',data:cat}" *ngFor="let childCat of cat.Children | sort :'SortIndex'">
        <app-category-accordian [cat]="childCat" [CurUser]="CurUser">

        </app-category-accordian>
      </div>
      <div cdkDrag [cdkDragDisabled]="!CurUser.IsTolomaticUser" [cdkDragData]="{type:'file',data:file}" *ngFor="let file of cat.Files | sort : 'Index'" class="infoCenterTile row-no-margin">
        <div *cdkDragPreview>{{file.Description}}</div>
        <!--Filename-->
        <div class="col-md-4 clear-padding">
          <span style="font-size:20px; line-height:20px;font-weight:700;">{{file.Description}}</span>
          <br />
          <span style="font-size:15px;line-height:20px;">Updated {{file.UpdateDate | date: 'short'}}</span>
        </div>
        <!--File Type/Category-->
        <div class="col-md-2 clear-padding" style="text-align:center;">
          <span style="font-size:15px;line-height:20px;font-weight:600;">Doc type</span>
          <br />
          <span>{{cat.Name}}</span>
        </div>
        <div class="col-md-2 clear-padding" style="text-align:center;">
          <span style="font-size:15px;line-height:20px;font-weight:600;">Status</span>
          <br />
          <span [ngClass]="{'green': file.Active, 'red':!file.Active }">{{file.Active ? "Active" : "Inactive"}}</span>
        </div>
        <div class="col-md-4 clear-padding" style="text-align:right;">

          <!--<img alt="download" class="clickable" (click)="DownloadFile(file)" src="./assets/images/icon-downloads-blue.svg" />-->
          <span style="padding-right:10px;" title="Edit">
            <fa-icon *ngIf="CurUser.IsTolomaticUser" [icon]="faPenToSquare" (click)="EditFile(file)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
          </span>
          <span style="padding-right:10px;" title="Download">
            <fa-icon [icon]="faArrowDown" (click)="DownloadFile(file)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
          </span>
          <span style="padding-left:10px;padding-right:10px;" title="Delete">
            <fa-icon *ngIf="CurUser.IsTolomaticUser" [icon]="faX" (click)="RemoveFile(file)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
          </span>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
